export default class {
    constructor(Configurator) {
        this.Configurator = Configurator;
        // Constants
        this.CONTAINER_POPUP    = 'popup';
        this.CONTAINER_INLINE   = 'container';
    }

    preload() {
        return Promise.all([
            App.Components.wait(this.Configurator.container, 'Overlay'),
            App.wait('App.Components.Popup'),
        ]).then(values => {
            this.inline = values.shift();
            this.popup  = values.shift();
        });
    }

    showViewInterface(show) {
        this.Configurator.Design.container.classList.toggle('show-view-interface', show);
    }

    select(current) {
        document.querySelectorAll('.sidebar-item[data-identifier]')
            .forEach(e => e.classList.remove('selected'));
        const menuItem = document.querySelector('.sidebar-item[data-identifier="' + current + '"]');
        if (menuItem) menuItem.classList.add('selected');
    }

    async summary(level) {
        const Configurator  = this.Configurator;
        const cta           = Configurator.Design.Summary.cta;
        const Summary       = Configurator.Design.Summary;
        const Bottom        = Configurator.Bottom;
        switch (level) {
            case Configurator.PURCHASE_LEVEL_LOW:
                Summary.hidePrice(false);
                Bottom.showExtraInfo(true);
                if (!cta) break;
                cta.type    = 'standard';
                if (this.Configurator.Design.product) {
                    cta.content = __('GLOBAL.PLACE_IN_THE_SHOPPING_CART');
                    cta.container.setAttribute('onclick','Design.submit()');
                } else if (App.Variable('isProposalsEnabled')) {
                    cta.content = __('GLOBAL.CONTINUE');
                    cta.container.setAttribute('onclick', 'Design.Proposals.show()');
                } else {
                    cta.content = __('GLOBAL.ADJUST_INGREDIENTS');
                    cta.container.setAttribute('onclick','Design.back()');
                }
                break;
            case Configurator.PURCHASE_LEVEL_MEDIUM:
                Summary.hidePrice(true);
                Bottom.showExtraInfo(false);
                if (!cta) break;
                cta.type    = 'disabled';
                cta.content = __('MIXER.DESIGN.NEXT');
                cta.container.setAttribute('onclick','Configurator.next()');
                break;
            case Configurator.PURCHASE_LEVEL_HIGH:
                Summary.hidePrice(true);
                Bottom.showExtraInfo(false);
                if (!cta) break;
                cta.type    = 'standard';
                cta.content = __('MIXER.DESIGN.NEXT');
                cta.container.setAttribute('onclick','Configurator.next()');
                break;
        }
    }

    async call(url, container) {
        if (this.container !== container) {
            await this.Configurator.normalize();
            this.container = App.Interface.Utilities.isMobile() ? this.CONTAINER_POPUP : this.CONTAINER_INLINE;
        }
        this.inline.empty();
        switch (this.container || this.CONTAINER_POPUP) {
            case this.CONTAINER_POPUP:
                App.Components.Popup.showXMLHttpRequestContent(url);
                break;
            case this.CONTAINER_INLINE:
                Promise.all([App.Page.get(url)], this.preload()).then(values => {
                    this.inline.setPage(values.shift());
                });
                break;
        }
    }
}
